import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { PeopleIcon } from '@ui/custom-icons';
import { cn } from '@ui/primitives/utils';
import { RouteNames } from '@ui/routes';
import { BackgroundCard } from '../BackgroundCard';
import { AvatarList } from '../card-item-elements';
function PeopleCard(param) {
    let { peopleList, organizationName, title, moreLink, moreLinkDisabled } = param;
    return /*#__PURE__*/ _jsx(BackgroundCard, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col w-full max-w-[17.625rem] bg-card rounded-lg p-1 text-sm text-muted-foreground",
            "data-e2e": "people-card",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between gap-2 [&>h3]:font-medium [&>h3]:text-base [&>h3]:text-foreground [&>h3]:m-0",
                    "data-e2e": "people-card-header",
                    children: [
                        /*#__PURE__*/ _jsx("h3", {
                            children: title !== null && title !== void 0 ? title : 'People'
                        }),
                        !moreLinkDisabled && /*#__PURE__*/ _jsx(Link, {
                            className: "white",
                            to: moreLink !== null && moreLink !== void 0 ? moreLink : RouteNames.ORGANIZATION_PEOPLE,
                            params: moreLink == null ? {
                                organization: organizationName
                            } : undefined,
                            children: "Show more"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-1 mt-1",
                    "data-e2e": "people-card-members-count",
                    children: [
                        /*#__PURE__*/ _jsx(PeopleIcon, {
                            color: "#27584D",
                            width: 18,
                            height: 18
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                peopleList.length,
                                " ",
                                peopleList.length > 1 ? 'members' : 'member'
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn('flex gap-2 mt-4'),
                    "data-e2e": "people-card-avatar-list",
                    children: /*#__PURE__*/ _jsx(AvatarList, {
                        list: peopleList,
                        showAmount: 6
                    })
                })
            ]
        })
    });
}
export { PeopleCard };
